export default __webpack_public_path__ + "1682d45bdd5a0c5e937a0c4031780264.png";